/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.8.0",
  "gitBuildTime": "2026-10-19T18:20:47.958Z",
  "gitBuildVersion": "1.8.0",
  "gitCommitId": "4e12096",
  "gitCommitIdFull": "4e120963f1087509069d79b2a6310df8e96a3e83",
  "gitCommitTime": "2026-10-19T18:18:52.000Z",
  "version": "1.8.0-2026-10-19T18:18:52.000Z-(4e12096)"
};
